import script from "./PrivacyPolicy.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivacyPolicy.vue?vue&type=script&setup=true&lang=js"

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=f5233f06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5233f06"]])

export default __exports__